import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

Swiper.use([Navigation]);

export default function () {
	// Initiate the swiper
	const cardCarousels = document.querySelectorAll('.js-card-carousel');

	cardCarousels.forEach((carousel) => {
		if (carousel.querySelectorAll('.swiper-slide').length > 1) {
			const config = {
				navigation: {
					nextEl: carousel.previousElementSibling.querySelector(
						'.card-carousel__next'
					),
					prevEl: carousel.previousElementSibling.querySelector(
						'.card-carousel__prev'
					),
				},
				slidesPerView: 'auto',
				spaceBetween: 48,
				sticky: true,
				threshold: 20,
			};

			new Swiper(carousel, config);
		}
	});
}
